import { useTranslation } from 'react-i18next'

const features = [
  {
    icon: 'ri-stack-line',
    titleKey: 'home.feature1Title',
    descKey: 'home.feature1Desc',
    color: 'accent',
  },
  {
    icon: 'ri-group-line',
    titleKey: 'home.feature2Title',
    descKey: 'home.feature2Desc',
    color: 'primary',
  },
  {
    icon: 'ri-focus-3-line',
    titleKey: 'home.feature3Title',
    descKey: 'home.feature3Desc',
    color: 'secondary',
  },
  {
    icon: 'ri-smartphone-line',
    titleKey: 'home.feature4Title',
    descKey: 'home.feature4Desc',
    color: 'accent',
  },
]

const colorMap: Record<string, { bg: string; text: string }> = {
  accent: { bg: 'bg-accent-100', text: 'text-accent-600' },
  primary: { bg: 'bg-primary-100', text: 'text-primary-600' },
  secondary: { bg: 'bg-secondary-100', text: 'text-secondary-600' },
}

export default function FeaturesSection() {
  const { t } = useTranslation('common')

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="mx-auto px-4 md:px-6 max-w-7xl">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            {t('home.featuresTitle')}
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            {t('home.featuresSubtitle')}
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {features.map((feat) => {
            const colors = colorMap[feat.color]
            return (
              <div key={feat.icon} className="group bg-background-100 rounded-2xl p-6 md:p-8 hover:bg-background-200/70 transition-colors duration-300">
                <div className={`w-12 h-12 md:w-14 md:h-14 rounded-xl ${colors.bg} flex items-center justify-center mb-5 group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${feat.icon} ${colors.text} text-xl md:text-2xl`}></i>
                </div>
                <h3 className="font-heading text-base md:text-lg text-foreground-950 mb-2">
                  {t(feat.titleKey)}
                </h3>
                <p className="text-foreground-500 text-sm leading-relaxed">
                  {t(feat.descKey)}
                </p>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}